import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { InViewportDirective } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SdBannerContentModule } from '../banner-content';
import { SdFormattedResponsiveBannerComponent } from './formatted-responsive-banner.component';

@NgModule({
  declarations: [SdFormattedResponsiveBannerComponent],
  imports: [
    NgIf,
    AsyncPipe,
    GenericLinkComponent,
    SdBannerContentModule,
    InViewportDirective,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RosaFormattedResponsiveBannerComponent]: {
          component: SdFormattedResponsiveBannerComponent,
        },
      },
    }),
  ],
  exports: [SdFormattedResponsiveBannerComponent],
})
export class SdFormattedResponsiveBannerModule {}
